import Wrapper from "../../../../components/layout/Wrapper";
import logo from "../../../../assets/Images/logo.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faSignOut} from "@fortawesome/free-solid-svg-icons";
import ButtonLink from "../../../../components/elements/ButtonLink";
import React from "react";
import ProgressBar from "../../../../components/elements/ProgressBar";
import {useParams} from "react-router-dom";

const HeaderProject = () => {
    const {course_id} = useParams();

    return (
        <header className='mb-4 border-b-4 border-gray-200 py-3'>
            <Wrapper>
                <div className='w-full flex flex-1 items-center'>

                    <div className='flex gap-x-3 items-center'>
                        <img src={logo} alt='Codepro' className='h-16'/>
                        <span className='text-2xl font-bold'>کدپرو</span>
                    </div>

                    <div className='mr-auto flex gap-x-5'>
                        <ButtonLink to={`/fa/account/course/${course_id}/content`}>
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </ButtonLink>
                    </div>

                </div>
            </Wrapper>
        </header>
    );
};

export default HeaderProject;